import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IShareService = ( createDecorator('shareService'));
export { IShareService };
